import { Document } from '@contentful/rich-text-types';
import { ContentImage, ContentMedia, Deserializable, JsonObject } from '@ktypes/models';
import { isDialogueActionTypeSupported } from './dialogue-action.types';

export class DialogueAction implements Deserializable<JsonObject, DialogueAction> {
  constructor(
    public type?: string,
    public label?: string,
    public params?: JsonObject,
    public resultKey?: string
  ) {}

  deserialize(input: JsonObject): DialogueAction {
    if (input == null) {
      return null;
    }

    this.type = input['type'] as string;
    this.label = input['label'] as string;
    this.params = input['params'] as JsonObject;
    this.resultKey = input['resultKey'] as string;

    return this;
  }
}

export class DialogueInformation implements Deserializable<JsonObject, DialogueInformation> {
  constructor(
    public headerMedia?: ContentImage,
    public header?: string,
    public body?: Document,
    public buttonText?: string,
    public media?: ContentMedia,
    public primaryAction?: DialogueAction,
    public secondaryAction?: DialogueAction
  ) {}

  deserialize(input: JsonObject): DialogueInformation {
    if (input == null) {
      return null;
    }

    this.headerMedia = new ContentImage().deserialize(input['headerMedia']);
    this.header = input['header'] as string;
    this.body = input['body'] as Document;
    this.buttonText = input['buttonText'] as string;
    this.media = new ContentMedia().deserialize(input['mediaElement']);
    this.primaryAction = new DialogueAction().deserialize(input['primaryAction'] as JsonObject);
    this.secondaryAction = new DialogueAction().deserialize(input['secondaryAction'] as JsonObject);

    return this;
  }

  /**
   * An action block is atomic: presence of a [primaryAction] switches the block
   * into action mode (dual buttons instead of the single CTA / arrow nav).
   */
  get hasActions(): boolean {
    return this.primaryAction != null;
  }

  /**
   * Whether this client can fully honor the primary action. When false, the whole
   * block is skipped (no action-coupled copy is rendered).
   */
  get isPrimaryActionSupported(): boolean {
    return isDialogueActionTypeSupported(this.primaryAction?.type);
  }
}
